import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0a159980")

_pushScopeId("data-v-0a159980")
const _hoisted_1 = { class: "all" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "my-info-title" }, "可申请的订单", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "hit" }, " *初始可申请订单只保留近30天订单 ", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "el-icon-s-order" }, null, -1)
const _hoisted_5 = { style: {"margin-left":"10px"} }
const _hoisted_6 = { style: {"margin-left":"10px"} }
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "el-icon-time" }, null, -1)
const _hoisted_8 = { style: {"margin-left":"10px"} }
const _hoisted_9 = { style: {"margin-left":"10px"} }
const _hoisted_10 = { style: {"margin-left":"10px"} }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("申请")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_divider = _resolveComponent("el-divider")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table = _resolveComponent("el-table")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_el_divider, { id: "bottom-divider" }),
    _hoisted_3,
    _createVNode(_component_el_table, {
      border: "",
      style: {"border-radius":"5px","width":"100%"},
      "header-cell-style": { background: '#eef1f6', color: '#606266' },
      data: _ctx.tableData,
      "row-key": "userId",
      lazy: ""
    }, {
      default: _withId(() => [
        _createVNode(_component_el_table_column, {
          type: "index",
          index: _ctx.row
        }, null, 8, ["index"]),
        _createVNode(_component_el_table_column, {
          label: "订单号",
          width: "100"
        }, {
          default: _withId((scope) => [
            _hoisted_4,
            _createVNode("span", _hoisted_5, _toDisplayString(scope.row.orderId), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "出发地->目的地",
          width: "150"
        }, {
          default: _withId((scope) => [
            _createVNode("span", _hoisted_6, _toDisplayString(scope.row.depart) + "->" + _toDisplayString(scope.row.destination), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "出行日期",
          width: "100"
        }, {
          default: _withId((scope) => [
            _hoisted_7,
            _createVNode("span", _hoisted_8, _toDisplayString(scope.row.date), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "订单金额",
          width: "100"
        }, {
          default: _withId((scope) => [
            _createVNode("span", _hoisted_9, _toDisplayString(scope.row.cost), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "航班号",
          width: "100"
        }, {
          default: _withId((scope) => [
            _createVNode("span", _hoisted_10, _toDisplayString(scope.row.flightId), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "操作" }, {
          default: _withId((scope) => [
            _createVNode(_component_el_button, {
              size: "mini",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleEdit()))
            }, {
              default: _withId(() => [
                _hoisted_11
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])
  ]))
})